import { type HTMLAttributes } from "react";
import { cn } from "@vseh/ui";

/**
 * Маленький логотип-знак VSEH в круге AI-цвета. Используется в начале
 * каждого AgentBubble и ToolCallCard. Размер пропорционален bubble'у.
 */
export interface AgentAvatarProps extends HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg";
}

const sizeMap = {
  sm: "size-6 text-xs",
  md: "size-8 text-sm",
  lg: "size-10 text-md",
} as const;

export function AgentAvatar({ size = "md", className, ...props }: AgentAvatarProps): JSX.Element {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full bg-ai-500 font-display font-extrabold text-white",
        sizeMap[size],
        className,
      )}
      {...props}
    >
      ▣
    </div>
  );
}
